import { useState } from "react"
import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table18 from "./components/Factors/Table/Table18";
import Table19 from "./components/Factors/Table/Table19";
const PageG7 = ({ reload }) => {
  const [koosheshFekriScore, setKoosheshFekriScore] = useState("")
  const [masoliatKhas, setMasoliatKhas] = useState("")
  return (
    <>
      <Page pageNumber={31}>
        <HeaderFactors
          numberFactors="عامل چهاردهم"
          titelFactors="مسئوليت خاص"
          maxValue="20"
          jsValue={masoliatKhas}
        />
        <ExplainFactor
          text="مسئولیت خاص عبارت است از مسئولیت در قبال سلامت معاملات، اطلاعات حساس، رازداری وعواقب
          حقوقی وقانونی ناشی از تصمیم گیری در مورد صحت یا نگهداری موثر اطلاعات ارزشمند."
        />
        <Table18 masoliatKhas={masoliatKhas} setMasoliatKhas={setMasoliatKhas} reload={reload}/>
        <SpaceBetweenTables />
        <HeaderFactors
          numberFactors="عامل پانزدهم"
          titelFactors="کوشش فكری، دقت و تمرکز حواس"
          maxValue="60"
          jsValue={koosheshFekriScore}
        />
        <ExplainFactor
          text="میزان تلاش فکری، میزان قدرت تصمیم گیری، تجزیه وتحلیل مسائل، طراحی و برنامه ریزی، تجسم و
          قضاوت، سرعت انتقال وابتکار وتدوین خط ومشی ومقررات."
        />
        <Table19 koosheshFekriScore={koosheshFekriScore} setKoosheshFekriScore={setKoosheshFekriScore} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG7;
